import React from "react";

import _ from "lodash";

import { AttachmentType } from "components/ui/AttachmentPicker";

import { calculateStatus, createAttachmentType } from "utils/utils";

function useSingleFile({ setForm }: { setForm: React.Dispatch<React.SetStateAction<any>> }) {
    const setSingleFile = React.useCallback(
        (fileToSet: AttachmentType, path: string) => {
            setForm((prevForm: any) => {
                const newForm = _.cloneDeep(prevForm);

                if (fileToSet && newForm[path]) {
                    newForm[path] = createAttachmentType({
                        filename: fileToSet.filename,
                        content: fileToSet.content,
                        contentType: fileToSet.contentType ?? "",
                        size: fileToSet.size,
                        label: fileToSet.label,
                        status: calculateStatus(fileToSet.filename, fileToSet.content),
                    });
                } else if (newForm[path]) {
                    newForm[path] = createAttachmentType({
                        label: "not_present",
                        status: 0,
                    });
                }

                return newForm;
            });
        },
        [setForm]
    );

    return React.useMemo(() => ({ setSingleFile }), [setSingleFile]);
}

export default useSingleFile;
